import React from "react";
import { graphql } from "gatsby";
import { Steps as StepsComponent } from "@zempler/theme/src/components/steps/Steps";

export const Steps = ({ data, ...rest }) => {
  return <StepsComponent {...data} {...rest} />;
};

export const StepsQuery = graphql`
  fragment Steps on UMBRACO_StepsComponentType {
    steps: stepItems {
      heading
      text
      backgroundColor
      link {
        ...Link
      }
    }
  }
`;
